/**
 * Web-app i18n setup.
 *
 * Uses the same pattern as apps/web-marketing/src/i18n/setup.ts.
 * The shared `i18n` package's `createWebI18n()` statically bundles
 * FR/EN/ES/PT × common/marketing/legal JSONs — no HTTP backend needed.
 *
 * Import from 'i18n/web' (not root barrel) to avoid bundling mobile-only
 * modules (expo-localization, async-storage) in the Vite build.
 */
import {
  createWebI18n,
  WEB_SUPPORTED_LANGUAGES,
  WEB_DEFAULT_LANGUAGE,
  type WebLanguage,
} from 'i18n/web';

function detectInitialLanguage(): WebLanguage {
  if (typeof navigator === 'undefined') return WEB_DEFAULT_LANGUAGE;
  const candidates = [
    ...(navigator.languages ?? []),
    navigator.language,
  ].filter(Boolean);
  for (const raw of candidates) {
    const code = raw.toLowerCase().slice(0, 2);
    if ((WEB_SUPPORTED_LANGUAGES as readonly string[]).includes(code)) {
      return code as WebLanguage;
    }
  }
  return WEB_DEFAULT_LANGUAGE;
}

export const i18n = createWebI18n({
  lng: detectInitialLanguage(),
  defaultNS: 'common',
});

export default i18n;
